import fetch from "isomorphic-fetch";
import store from "store";
import { getURL } from "../Utils";
import { List } from "immutable";

export const SET_URL_LAUNCH_OPTIONS = "SET_ULR_LAUNCH_OPTIONS";
export function setURLLaunchOptions(options) {
  return {
    type: SET_URL_LAUNCH_OPTIONS,
    options: options,
  };
}

export const SET_LAUNCH_OPTIONS = "SET_LAUNCH_OPTIONS";
export function setLaunchOptions(options) {
  return {
    type: SET_LAUNCH_OPTIONS,
    options: options,
  };
}

export const SET_LAUNCH_ERROR = "SET_LAUNCH_ERROR";
export function setLaunchError(game) {
  return {
    type: SET_LAUNCH_ERROR,
    game: game,
  };
}

export const GET_GAMES = "GET_GAMES";

export function getGames() {
  return {
    type: GET_GAMES,
  };
}

export const RECEIVE_GAMES = "RECEIVE_GAMES";
export function receiveGames(json) {
  return (dispatch) => {
    dispatch({
      type: RECEIVE_GAMES,
      games: {
        games: json.results || [],
        favouriteGames: store.get("favouriteGames") || [],
      },
    });

    dispatch(filterGames(""));
  };
}

export const RECEIVE_OGA_INFORMATION = "RECEIVE_OGA_INFORMATION";
export function receiveOgaInformation(json) {
  return {
    type: RECEIVE_OGA_INFORMATION,
    oga_version: json.oga.game.version,
  };
}

export function fetchOgaInformation() {
  return function (dispatch) {
    const ogaInfoHeaders = new Headers();
    ogaInfoHeaders.append("Content-Type", "application/json");
    ogaInfoHeaders.append("Accept", "application/json");
    ogaInfoHeaders.append(
      "Authorization",
      'OGA-Host-Token token="token-gbp_user_1"'
    );

    const currentURL = getURL();

    return fetch(currentURL + "/game/1?ccy=GBP", { headers: ogaInfoHeaders })
      .then((response) => response.json())
      .then((json) => dispatch(receiveOgaInformation(json)));
  };
}

export function fetchGames() {
  return async function (dispatch) {
    await dispatch(getGames());
    const ogaInfoHeaders = new Headers();
    ogaInfoHeaders.append("Content-Type", "application/json");
    ogaInfoHeaders.append("Accept", "application/json");

    const currentURL = getURL();

    const response = await fetch(currentURL + "/game", {
      headers: ogaInfoHeaders,
    });
    const json = await response.json();
    return dispatch(receiveGames(json));
  };
}

export const FILTER_GAMES = "FILTER_GAMES";
export function filterGames(filter) {
  return (dispatch, getState) => {
    const state = getState();
    const orderedGames = state.environment_information.get("orderedGames");

    let filteredGames = orderedGames;
    if (filter !== "") {
      filteredGames =
        orderedGames.filter(
          (game) =>
            game.get("game").toUpperCase().indexOf(filter.toUpperCase()) > -1
        ) || List();
    }

    dispatch({
      type: FILTER_GAMES,
      games: filteredGames,
    });
  };
}

export const TOGGLE_FAVOURITE_GAME = "TOGGLE_FAVOURITE_GAME";
export function toggleFavouriteGame(game) {
  return (dispatch) => {
    const favouriteGames = store.get("favouriteGames");

    if (favouriteGames) {
      const favouriteGameIndex = favouriteGames.findIndex(
        (favouriteGame) => favouriteGame.id === game.get("id")
      );

      if (favouriteGameIndex > -1) {
        // game exists - remove it
        favouriteGames.splice(favouriteGameIndex, 1);
      } else {
        // game doesn't exist - add it
        favouriteGames.push(game);
      }
      store.set("favouriteGames", favouriteGames);
    } else {
      store.set("favouriteGames", [game]);
    }

    dispatch({
      type: TOGGLE_FAVOURITE_GAME,
      favouriteGames: store.get("favouriteGames"),
    });
  };
}

export const SET_SORT_A_TO_Z = "SET_SORT_A_TO_Z";
export function setSortAToZ() {
  return (dispatch, getState) => {
    const state = getState();
    const filteredGames = state.environment_information.get("filteredGames");
    const sortedGames = filteredGames.sortBy((game) => game.get("game"));

    dispatch({
      type: SET_SORT_A_TO_Z,
      games: sortedGames,
    });
  };
}

export const SET_SORT_Z_TO_A = "SET_SORT_Z_TO_A";
export function setSortZToA() {
  return (dispatch, getState) => {
    const state = getState();
    const filteredGames = state.environment_information.get("filteredGames");
    let sortedGames = filteredGames
      .sortBy((game) => game.get("game"))
      .reverse();

    dispatch({
      type: SET_SORT_Z_TO_A,
      games: sortedGames,
    });
  };
}

export const SET_FILTER_MODE_TO_ALL = "SET_FILTER_MODE_TO_ALL";
export function setFilterModeToAll() {
  return (dispatch) => {
    dispatch({
      type: SET_FILTER_MODE_TO_ALL,
    });
  };
}

export const SET_FILTER_MODE_TO_REAL = "SET_FILTER_MODE_TO_REAL";
export function setFilterModeToReal() {
  return (dispatch) => {
    dispatch({
      type: SET_FILTER_MODE_TO_REAL,
    });
  };
}

export const SET_FILTER_MODE_TO_DEMO = "SET_FILTER_MODE_TO_DEMO";
export function setFilterModeToDemo() {
  return (dispatch) => {
    dispatch({
      type: SET_FILTER_MODE_TO_DEMO,
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/actions.js